import { Component } from '@angular/core';

@Component({
    selector: 'app-scripts-init',
    templateUrl: './scripts-init.component.html',
    standalone: false
})
export class ScriptsInitComponent {}
